module.exports = __webpack_public_path__ + "img/reading-1-en.95ba1399.png";